// Vendors
import $ from 'jquery';
import raf from 'raf';

import { oktaAuthClient, requestMFA } from './okta-login';

const gated = $('[data-gated]');
if (gated.length && gated.data('gated') === 'article') {
  const background = gated.find('.gated__background');
  const modal = gated.find('.gated__modal');
  const opacityStart = Number(background.css('opacity'));
  const opacityEnd = 1;

  const fadeBackground = () => {
    const backgroundOffset = background.offset().top;
    const windowHeight = window.innerHeight;
    const offsetTop = window.pageYOffset - backgroundOffset + windowHeight;

    if (offsetTop < 0) {
      return;
    } else if (offsetTop > 500) {
      modal.addClass('gated__modal--visible');
    } else {
      modal.removeClass('gated__modal--visible');
    }

    const backgroundOpacity = Math.abs(
      (offsetTop / 1000) * (opacityStart - opacityEnd)
    );

    raf(() => {
      background.css('opacity', backgroundOpacity);
    });
  };

  $(window).on('scroll', () => fadeBackground());
  fadeBackground();
}

// Article form
$('#gated-article-form').on('submit', (event) => {
  event.preventDefault();
});

// Resource form
$('#add-to-cart').on('click', (event) => {
  event.preventDefault();
  gated.removeClass('gated--hidden');
});

// PIP/FIP login
$('#add-to-cart, #pip-login, #fip-login').on('click', (event) => {
  event.preventDefault();
  gated.removeClass('gated--hidden');
});

// Close Modal
gated.find('[data-modal-close]').on('click', (event) => {
  event.preventDefault();
  gated.addClass('gated--hidden');
});

// Gated Login Functionality
let currentTransaction; // Used to share information into MFA scope

$('#gated-resource-form').on('submit', (event) => {
  event.preventDefault();

  const $submitBtn = $('#gated-resource-form__submit-btn');
  const email = $.trim($('#gated-resource-form input[name=email]').val());
  const password = $.trim($('#gated-resource-form input[name=password]').val());
  const data = $('#gated-resource-form').serialize();

  $submitBtn.addClass('btn--loading');

  oktaAuthClient &&
    oktaAuthClient
      .signInWithCredentials({
        username: email,
        password: password
      })
      .then(function (transaction) {
        if (transaction.status === 'SUCCESS') {
          $.ajax({
            type: 'POST',
            url: '/wp-admin/admin-ajax.php?action=gated_login',
            dataType: 'json',
            data: data,
            success: function (response) {
              $submitBtn.removeClass('btn--loading');

              if (response.data.error) {
                $('.notice--error .error').html(response.data.error);
                $('.notice--error').show();
              } else {
                if (
                  response.data.post_type !== 'product' &&
                  response.data.redirect_to
                ) {
                  window.location.href = response.data.redirect_to;
                  return;
                }

                if (response.data.post_id && response.data.is_download) {
                  gated.addClass('gated--hidden');

                  $.ajax({
                    type: 'POST',
                    url: '/wp-admin/admin-ajax.php?action=add_download',
                    dataType: 'json',
                    data: {
                      post_id: response.data.post_id,
                      asset_key: response.data.asset_key
                    },
                    success: function (response) {
                      if (response.data.redirect_url) {
                        oktaAuthClient.session.setCookieAndRedirect(
                          transaction.sessionToken
                        );
                      }
                    },
                    error: function (jqXHR, exception) {}
                  });
                } else {
                  const qty = $(
                    `[data-product-id="${response.data.post_id}"]`
                  ).val();

                  oktaAuthClient.session.setCookieAndRedirect(
                    transaction.sessionToken,
                    `${window.location.origin}/wp/?post_type=product&add-to-cart=${response.data.post_id}&quantity=${qty}`
                  );
                }
              }
            },
            error: function (jqXHR, exception) {
              $submitBtn.removeClass('btn--loading');
            }
          });
        } else if (transaction.status === 'MFA_REQUIRED') {
          currentTransaction = transaction;

          requestMFA(transaction).then((_) => {
            $submitBtn.removeClass('btn--loading');

            $('#gated-resource-form').hide();
            $('.gated__modal-title').text('Multi-Factor Authentication');
            $('.notice--error .error').html(
              "A verification code has been sent to user's email"
            );
            $('.notice--error').show();
            $('#gated-mfa-form').show();
          });
        } else {
          $submitBtn.removeClass('btn--loading');
          throw 'We cannot handle the ' + transaction.status + ' status';
        }
      })
      .catch(function (err) {
        console.error(err);

        $('.notice--error .error').html(err.message);
        $('.notice--error').show();

        $submitBtn.removeClass('btn--loading');
      });
});

// Gated Multifactor Authentication
$('#gated-mfa-form').on('submit', (event) => {
  event.preventDefault();

  const { factors } = currentTransaction;
  const data = $('#gated-resource-form').serialize();
  const verificationCode = $.trim(
    $('#gated-mfa-form input[name=verification]').val()
  );
  const $submitBtn = $('.gated-mfa-form__submit button.btn');

  $submitBtn.addClass('btn--loading');

  $.ajax({
    type: 'POST',
    xhrFields: { withCredentials: true },
    url: '/wp-admin/admin-ajax.php?action=wl_authenticate_mfa',
    dataType: 'json',
    data: {
      url: `/api/v1/authn/factors/${factors[0].id}/verify`,
      passCode: verificationCode,
      stateToken: currentTransaction.data.stateToken
    },
    success: (transaction) => {
      if (transaction.data.status === 'SUCCESS') {
        $.ajax({
          type: 'POST',
          url: '/wp-admin/admin-ajax.php?action=gated_login',
          dataType: 'json',
          data: data,
          success: function (response) {
            if (response.data.error) {
              $('.notice--error .error').html(response.data.error);
              $('.notice--error').show();
            } else {
              if (
                response.data.post_type !== 'product' &&
                response.data.redirect_to
              ) {
                window.location.href = response.data.redirect_to;
                return;
              }

              if (response.data.post_id && response.data.is_download) {
                gated.addClass('gated--hidden');

                $.ajax({
                  type: 'POST',
                  url: '/wp-admin/admin-ajax.php?action=add_download',
                  dataType: 'json',
                  data: {
                    post_id: response.data.post_id,
                    asset_key: response.data.asset_key
                  },
                  success: function (response) {
                    if (response.data.redirect_url) {
                      oktaAuthClient.session.setCookieAndRedirect(
                        transaction.data.sessionToken
                      );
                    }
                  },
                  error: function (jqXHR, exception) {}
                });
              } else {
                const qty = $(
                  `[data-product-id="${response.data.post_id}"]`
                ).val();
                oktaAuthClient.session.setCookieAndRedirect(
                  transaction.data.sessionToken,
                  `${window.location.origin}/wp/?post_type=product&add-to-cart=${response.data.post_id}&quantity=${qty}`
                );
              }
            }
          },
          error: function (jqXHR, exception) {}
        });
      } else {
        $submitBtn.removeClass('btn--loading');

        $('.notice--error .error').html(
          'The verification code you entered is incorrect'
        );
        $('.notice--error').show();

        console.error(transaction.data.errorSummary);
      }
    }
  }).catch((err) => {
    $('.notice--error').show();
    $('.notice--error .error').html(
      'The verification code you entered is incorrect'
    );
    console.error(err);
  });
});
